"use client";
import { SignInButton, useUser } from "@clerk/nextjs";
import { useEffect, useState } from "react";

import { css } from "@/../styled-system/css";

import AccountAvatar from "../Common/AccountAvatar";
import ProfileHeaderSkeleton from "../Skeleton/ProfileHeaderSkeleton";
import { Badge } from "../ui/Badge";
import Button from "../ui/Button";

function ProfileHeader() {
  const { isSignedIn: isSignedInClerk, user, isLoaded } = useUser();

  const [isSignedIn, setIsSignedIn] = useState<boolean | undefined>(
    !user ? false : true,
  );

  const [name, setName] = useState(user?.fullName || "");
  const [userImageUrl, setUserImageUrl] = useState(user?.imageUrl || "");
  const [emailAddress, setEmailAddress] = useState(
    user?.emailAddresses[0].emailAddress || "",
  );

  useEffect(() => {
    setIsSignedIn(isSignedInClerk);
    setName(user?.firstName || "");
    setUserImageUrl(user?.imageUrl || "");
    setEmailAddress(user?.emailAddresses[0].emailAddress || "");
  }, [isSignedInClerk, user]);

  return (
    <div className={css({ pb: "4", px: "1.5" })}>
      {isSignedIn ? (
        isLoaded ? (
          <div
            className={css({
              display: "flex",
              flexDirection: "row",
              gap: "3",
              whiteSpace: "nowrap",
              alignItems: "center",
            })}
          >
            <div className={css({ maxWidth: "44px" })}>
              <AccountAvatar src={userImageUrl} width="44px" />
            </div>
            <div
              className={css({
                width: "100%",
                minWidth: "0",
                fontFamily: "inter",
              })}
            >
              <div className={css({ display: "flex", flexDir: "row" })}>
                <div
                  className={css({
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                    color: "black",
                    lineHeight: "none",
                  })}
                >
                  <span
                    className={css({
                      fontSize: "lg",
                      fontWeight: "medium",
                    })}
                  >
                    {name}
                  </span>
                </div>
                {/* <Badge variant="membership">PRO</Badge> */}
              </div>
              <div
                className={css({
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  color: "black/50",
                })}
              >
                <span className={css({ fontWeight: "medium" })}>
                  {emailAddress}
                </span>
              </div>
            </div>
          </div>
        ) : (
          <ProfileHeaderSkeleton />
        )
      ) : (
        <SignInButton>
          <Button variant="primary" width="fit">
            LOG IN / REGISTER
          </Button>
        </SignInButton>
      )}
    </div>
  );
}

export default ProfileHeader;
